import styled from '@emotion/styled'

import { BANK_LINES_LIST_HEIGHT } from './constants/bankLinesListHeight'

export const BankLinesWrapper = styled.div`
  height: ${BANK_LINES_LIST_HEIGHT}px;
`
